import { measuredText } from './textMetrics';

// Arc model shared with textPath(): total angle θ = |curve|°, radius r = advance / θ, signed sagitta S = ±r(1 − cos θ/2).
const MAX = 150, DAMP = .5, rad = d => d * Math.PI / 180;
const sagittaOf = (curve, advance) => { const t = rad(Math.abs(curve)); return t < 1e-4 ? 0 : Math.sign(curve) * advance / t * (1 - Math.cos(t / 2)); };
function curveOf(S, advance) {
  const target = Math.abs(S);
  let lo = 0, hi = MAX;
  if (Math.abs(sagittaOf(hi, advance)) <= target) return Math.sign(S) * MAX;
  for (let i = 0; i < 30; i += 1) { const mid = (lo + hi) / 2; if (sagittaOf(mid, advance) < target) lo = mid; else hi = mid; }
  const deg = Math.round(lo);
  return deg < 3 ? 0 : Math.sign(S) * deg;
}

export const curveGeometry = o => {
  const g = measuredText(o);
  if (g.advance === undefined) return null;
  const curve = o.curve || 0, t = rad(Math.abs(curve)), r = t < 1e-4 ? Infinity : g.advance / t;
  return { ...g, curve, r, frame: `scale(${g.sx} ${g.sy})${Math.abs(g.skew) >= .5 ? ` skewX(${g.skew})` : ''} translate(${g.ox} ${g.oy})` };
};

// Dragging the apex handle bends around the chord fixed at drag start; damped ×0.5 for fine control on small text.
export function curvePatch(o, p, g) {
  const r = rad(o.rotation || 0), dx = p.x - o.x, dy = p.y - o.y, ly = (-dx * Math.sin(r) + dy * Math.cos(r)) * (o.flipY ? -1 : 1);
  const ty = ly / (o.scale || 1) / (g.sy || 1) - g.oy, S = sagittaOf(o.curve || 0, g.advance) - (ty - g.baseY) * DAMP;
  const curve = curveOf(S, g.advance);
  return { patch: { curve }, label: curve ? `Wölbung ${curve > 0 ? 'nach oben' : 'nach unten'} ${Math.abs(curve)}°` : 'Gerade · 0°' };
}
